import { FetchError } from 'ofetch'

export interface ValidationError extends FetchError<{
  message: string
  validationErrors: Record<string, string[]>
}> {}

export const isValidationError = (e: unknown): e is ValidationError =>
  !!e && e instanceof FetchError && !!e.data && 'validationErrors' in e.data
